<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/capacidade"> Cadastro/Equipamento/Capacidades </router-link>
      <label class="labelBar"> / </label>
      <label v-if="!readOnly"> Editar</label>
      <label v-else> Ver</label>
    </div>
    <tab-navegacao-equipamento />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col>
            <v-text-field
              label="Capacidade *"
              v-model="descricao"
              v-uppercase
              :counter="200"
              :readonly="readOnly"
              :rules="[(v) => !!v || 'O nome da capacidade é obrigatório']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="grupoEquipamento.ativo"
            @click.native.stop.prevent="checkAssociacao()"
            label="Ativo"
            :readonly="readOnly"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6" class="text-right">
          <v-btn to="/capacidade" color="error" class="mr-4" v-if="!readOnly">
            Voltar
          </v-btn>
          <v-btn to="/capacidade" color="success" class="mr-4" v-else>
            Voltar
          </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4" v-if="!readOnly">
            Salvar
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import TabNavegacaoEquipamento from "../../Tabs/TabCadastroEquipamento";
import { editarGrupoEquipamentoAsync } from "../../../services/grupoEquipamentoService";
import { mapState, mapActions } from "vuex";
import { getUserPermission } from "@/services/loginService";

export default {
  name: "editarGrupoEquipamento",
  data: () => ({
    overlay: false,
    valid: true,
    descricao: null,
    readOnly: false,
  }),
  computed: {
    ...mapState("grupoEquipamento", ["grupoEquipamento"]),
    ...mapState("produto", ["produtos"]),
  },
  methods: {
    ...mapActions("produto", ["atualizarProdutos"]),
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await editarGrupoEquipamentoAsync(
          this.grupoEquipamento.id,
          this.descricao,
          this.grupoEquipamento.ativo
        );
        if (resposta) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta.message, "Desculpe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$store.dispatch("ui/showSnackbar", {
            text: "Atualizado com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push("/capacidade");
        }
      }
    },
    findProduto(grupoEquipamentoId) {
      return this.produtos.filter((p) => {
        return p.idGrupoEquipamento == grupoEquipamentoId && p.ativo === true;
      });
    },
    checkAssociacao: async function () {
      if (!this.grupoEquipamento.ativo) {
        if (!this.produtos || this.produtos.length == 0) {
          this.overlay = true;
          await this.atualizarProdutos();
          this.overlay = false;
        }
        var produtos = this.findProduto(this.grupoEquipamento.id);
        if (produtos != null && produtos.length > 0) {
          this.$alert(
            "O(s) produtos(s) '" +
              produtos.map((e) => e.descricao).join("', '") +
              "' estão ativos e associados a essa Família.",
            "Ação não permitida!",
            "error"
          );
          this.grupoEquipamento.ativo = !this.grupoEquipamento.ativo;
        }
      }
    }
  },
  created: function () {
    this.readOnly = !getUserPermission(7);
    this.descricao = this.grupoEquipamento.descricao;
  },
  components: {
    TabNavegacaoEquipamento,
  },
};
</script>